export * from './lib/chat-notifications.service';
export * from './lib/chats-dashboard.store';
export * from './lib/components/chat-list-dialog/chat-list-dialog.component';
export * from './lib/components/chat/chat.component';
export * from './lib/has-access-to-chat.guard';
export * from './lib/ng-chats.module';
